<template>
  <div>
    <b>{{selected===to?"☛":""}}</b>
    <a :href = 'to' @click.prevent="change">
      <slot></slot>
    </a>
  </div>
</template>
<script>
    import Vue from "vue";
    let bus = new Vue();
    export default {
        name: "clickshow",
        data() {
            return {
            selected: "http://www.baidu.com"
            };
        },
        props: ["to"],
        mounted(){
            const _this = this
            bus.$on("changestate",function(input){
                _this.selected = input
            })
        },
        methods:{
            change(){
                bus.$emit("changestate",this.to)
            }
        }
    };
</script>